export default class Section {

    constructor(id, name, context){
        this.id = id;
        this.name = name;
        this.context = context;
    }

    getId(){
        return this.id;
    }

    getName(){
        return this.name;
    }

    setId(id){
        this.id = id;
    }

    setName(name){
        this.name = name;
    }

    setContext(context){
        this.context = context;
    }

    getContext(){
        return this.context;
    }
}